import React, { FC } from 'react'

import * as SC from './styled'

export type UnderlineTitleProps = {
  className?: string
  text: string
}

const UnderlineTitle: FC<UnderlineTitleProps> = (props) => {
  const { className, text } = props

  return <SC.Text className={className}>{text}</SC.Text>
}

export default UnderlineTitle
